var DynamicFieldsType;
(function (DynamicFieldsType) {
    DynamicFieldsType["AUTOCOMPLETE"] = "AUTOCOMPLETE";
    DynamicFieldsType["CHECKBOX"] = "CHECKBOX";
    DynamicFieldsType["CHECKLIST"] = "CHECKLIST";
    DynamicFieldsType["DATE_FIELD"] = "DATE_FIELD";
    DynamicFieldsType["DYNAMIC_FIELDS"] = "DYNAMIC_FIELDS";
    DynamicFieldsType["FIELD"] = "FIELD";
    DynamicFieldsType["FIELD_SET"] = "FIELD_SET";
    DynamicFieldsType["INPUT"] = "INPUT";
    DynamicFieldsType["RADIO_GROUP"] = "RADIO_GROUP";
    DynamicFieldsType["TEXT"] = "TEXT";
    DynamicFieldsType["TEXT_AREA"] = "TEXT_AREA";
})(DynamicFieldsType || (DynamicFieldsType = {}));
export default DynamicFieldsType;
//# sourceMappingURL=dynamic-fields-types.js.map